"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePromoBannerConfig = void 0;
var parsePromoBannerConfig = function (raw) {
    if (!raw)
        return null;
    if (typeof raw === 'string') {
        try {
            var parsed = JSON.parse(raw);
            return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
                ? parsed
                : null;
        }
        catch (_a) {
            return null;
        }
    }
    if (typeof raw === 'object' && !Array.isArray(raw)) {
        return raw;
    }
    return null;
};
exports.parsePromoBannerConfig = parsePromoBannerConfig;
